import { render, staticRenderFns } from "./event-list.vue?vue&type=template&id=52d2e437&scoped=true&"
import script from "./event-list.vue?vue&type=script&lang=js&"
export * from "./event-list.vue?vue&type=script&lang=js&"
import style0 from "./event-list.vue?vue&type=style&index=0&id=52d2e437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2e437",
  null
  
)

export default component.exports